import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Pagination, PaginationItem } from "@mui/material";
import { type ReactNode, useMemo, useState } from "react";

export function PaginationWrapper<T extends { [key: string]: unknown }[]>({
  data,
  renderPage,
  itemsPerPage,
}: {
  data: T;
  renderPage: (data: T) => ReactNode;
  itemsPerPage: number;
}): ReactNode {
  const [page, setPage] = useState(1);

  const totalPages = useMemo(
    () => Math.ceil(data.length / itemsPerPage),
    [data.length, itemsPerPage],
  );

  const displayPage = totalPages === 0 ? 1 : Math.min(page, totalPages);

  const pagedData = useMemo(() => {
    const startIndex = (displayPage - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage) as T;
  }, [data, displayPage, itemsPerPage]);

  return (
    <>
      {renderPage(pagedData)}
      <Box
        alignItems="center"
        sx={{
          p: 2,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Pagination
          renderItem={(item) => (
            <PaginationItem
              data-testid={item.type === "page" ? `pagination-page-${item.page}` : undefined}
              slots={{ previous: ArrowBack, next: ArrowForward }}
              {...item}
            />
          )}
          count={totalPages}
          page={displayPage}
          onChange={(_, pageNum) => {
            setPage(pageNum);
          }}
        />
      </Box>
    </>
  );
}
